import {$http} from '@/utils/https'
import {CHANGE_CATEGORY, CHANGE_LOADING, CHANGE_SKIP, SET_LIST, SET_LIST_LENGTH} from '../mutation-types';

import {GET_LIST,} from '../action-types';

const state = {
    listMy: [],
    list: [],
    skip: 0,
    limit: 9,
    listLength: 0,
    isLoadingList: false,
    activeCategory: '',
};

const getters = {
    listMy: state => state.listMy,
    list: state => state.list,
    listLength: state => state.listLength,
    skip: state => state.skip,
    isLoadingList: state => state.isLoadingList,
};

const actions = {
    [GET_LIST]: async ({commit}) => {
        try {
            commit(CHANGE_LOADING, true);
            commit(SET_LIST, []);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}store?skip=${state.skip}&limit=${state.limit}&include=course,modules,userCourse,userCourse.currentMaterial,userCourse.currentMaterial.lesson,userCourse.currentMaterial.module,image&filters[without_purchased]=1&filters[categories]=${state.activeCategory || ''}`);

            commit(SET_LIST, []);
            commit(SET_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);

            commit(CHANGE_SKIP);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },

    GET_MY_LIST: async ({commit}) => {
        try {
            commit(CHANGE_LOADING, true);
            commit('SET_MY_LIST', []);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}store?skip=${state.skip}&limit=99&include=course,modules,userCourse,userCourse.currentMaterial,userCourse.currentMaterial.lesson,userCourse.currentMaterial.module,image&filters[purchased]=1&filters[categories]=${state.activeCategory || ''}`);
            commit('SET_MY_LIST', []);
            commit('SET_MY_LIST', response.data.data);

            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    }
};

const mutations = {
    [SET_LIST](state, data) {
        // @TODO ??
        // state.list = data;
        state.list = [...state.list, ...data];

        // if (!data) return;
        // if (state.list && state.list.length) {
        //   state.list.push(...data);
        // } else {
        //   state.list = data;
        // }
    },

    SET_MY_LIST(state, data) {
        state.listMy = data;
        // @TODO ??
        // if (!data) return;
        // if (state.listMy) {
        // 	state.listMy.push(...data);
        // } else {
        // 	state.listMy = data;
        // }
    },

    [SET_LIST_LENGTH](state, data) {
        state.listLength = data;
    },
    [CHANGE_LOADING](state, status) {
        state.isLoadingList = status;
    },
    [CHANGE_SKIP](state) {
        state.skip += state.limit;
    },
    [CHANGE_CATEGORY](state, category) {
        state.activeCategory = category;
        state.skip = 0;
        state.listLength = 0;
        state.list = [];
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
